import React from 'react';

// Types
import {
  FormTypeType,
  ReviewFormTemplateType,
  TextareaQuestionType,
  QuestionTypeType,
} from 'Shared/types/ReviewFormTemplate.type';

// Hoooks
import { useQuestion } from './use-question';

// Components
import QuestionWrapper from './QuestionWrapper';
import WpTextField from 'Wpds/components/text-field/WpTextField';
import { WpButton } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';

type Props = {
  question: TextareaQuestionType;
  onChange: Function;
  handleDeleteQuestion: Function;
  handleDuplicateQuestion: Function;
  activeQuestionKey: string;
  setActiveQuestionKey: Function;
  handleMoveQuestion: Function;
  reviewFormType: FormTypeType;
  reviewFormTemplates: ReviewFormTemplateType[];
};

const TextareaQuestion = ({
  question,
  onChange,
  handleDeleteQuestion,
  handleDuplicateQuestion,
  activeQuestionKey,
  setActiveQuestionKey,
  handleMoveQuestion,
  reviewFormType,
  reviewFormTemplates,
}: Props) => {
  const { handleUpdateQuestion } = useQuestion({ question, onChange });

  const isActive = activeQuestionKey === question.key;

  return (
    <QuestionWrapper
      question={question}
      onChange={handleUpdateQuestion}
      handleDeleteQuestion={handleDeleteQuestion}
      activeQuestionKey={activeQuestionKey}
      setActiveQuestionKey={setActiveQuestionKey}
      handleDuplicateQuestion={handleDuplicateQuestion}
      handleMoveQuestion={handleMoveQuestion}
      reviewFormType={reviewFormType}
      reviewFormTemplates={reviewFormTemplates}
    >
      {isActive ? (
        <WpTextField
          id="textarea-explainer"
          name="textarea-explainer"
          label="textarea-explainer"
          value="User will be provided with text area to input written response"
          multiline={2}
          labelHidden
          disabled
        />
      ) : (
        <>
          {question.type === QuestionTypeType.HOLISTIC_SUMMARY && (
            <div className="mb-2">
              <WpButton variant="secondary">
                <WpIcon name="magic" />
                Generate Summary
              </WpButton>
            </div>
          )}
          <WpTextField
            id="short-answer-placeholder"
            label="Short answer"
            placeholder="Short Answer"
            labelHidden
            multiline={2}
            readOnly
          />
        </>
      )}
    </QuestionWrapper>
  );
};

export default TextareaQuestion;
